import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { appsettings } from '../shared/app.settings';
import { Product } from '../product/product.model';
import { BehaviorSubject } from 'rxjs';
@Injectable()
export class ProductRegisterService {
  public product = new BehaviorSubject<any>(null);

  constructor(
    private http: HttpClient,
  ) { }

  registerProduct(obj, country: string, language: string) {
    return this.http
      .post(appsettings.rootUrl + country + '/' + language + '/product-register', obj);
  }
}
